// extracted by mini-css-extract-plugin
export default {"outer":"IFrame_outer__INlSP","inner":"IFrame_inner__+OpBs","content":"IFrame_content__7PT13"};